import { aboutData } from '@/mocks/home';

export default function AboutSection() {
  return (
    <section id="about" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1400px] mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
            <div className="flex-1 w-full">
              <div className="relative w-full aspect-[4/3] rounded-2xl overflow-hidden max-w-lg mx-auto lg:max-w-none">
                <img
                  src="https://readdy.ai/api/search-image?query=Warm%20cinematic%20workspace%20with%20film%20editing%20suite%2C%20multiple%20monitors%20displaying%20movie%20timelines%2C%20soft%20golden%20ambient%20lighting%2C%20professional%20video%20production%20environment%2C%20modern%20minimal%20studio%2C%20creative%20atmosphere&width=800&height=600&seq=about-visual&orientation=landscape"
                  alt="春色影视团队工作环境"
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-r from-black/10 to-transparent rounded-2xl"></div>
              </div>
            </div>

            <div className="flex-1 w-full text-center lg:text-left">
              <h2 className="text-2xl md:text-4xl font-heading font-black text-foreground-950 mb-4">
                {aboutData.title}
              </h2>
              <div className="text-sm md:text-base text-foreground-600 leading-relaxed space-y-4 mb-8 max-w-lg mx-auto lg:mx-0">
                {aboutData.description.split('\n\n').map((paragraph, idx) => (
                  <p key={idx}>{paragraph}</p>
                ))}
              </div>

              <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 max-w-lg mx-auto lg:mx-0">
                {aboutData.stats.map((stat, idx) => (
                  <div key={idx} className="text-center p-3 bg-background-50 rounded-xl border border-background-200/70">
                    <div className="text-xl md:text-2xl font-heading font-black text-primary-500">
                      {stat.value}
                    </div>
                    <div className="text-xs text-foreground-500 mt-1">{stat.label}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}